import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { buildQueryString, getAllUtmParams } from '../utils/utm-params';

/**
 * InternalLink Component
 * React Router Link that preserves UTM parameters when navigating internally
 * 
 * Usage:
 * <InternalLink to="/formular-inscriere" className="btn btn-primary">
 *   Rezervă locul
 * </InternalLink>
 */
const InternalLink = ({ to, children, className, ...props }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    
    // Get all UTM parameters from current URL
    const params = getAllUtmParams();
    const queryString = buildQueryString(params);
    
    // Build destination with UTM params
    const destination = queryString ? `${to}${queryString}` : to;
    
        
    // Navigate with UTM params preserved
    navigate(destination);
  };

  return (
    <Link to={to} className={className} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
};

export default InternalLink;
